import LargeGreenSuccessIcon from "../components/icons/LargeGreenSuccessIcon";
import LargePinkErrorIcon from "../components/icons/LargePinkErrorIcon";

export const STATUSES = {
  AWAITING_EXPORT: "AWAITING_EXPORT",
  PENDING_SUPPLIER: "PENDING_SUPPLIER",
  EXPORTED_SUPPLIER: "EXPORTED_SUPPLIER",
  SUPPLIER_API_REQUEST_ERROR: "SUPPLIER_API_REQUEST_ERROR",
  SUPPLIER_ACCEPTED: "SUPPLIER_ACCEPTED",
  SUPPLIER_REJECTED: "SUPPLIER_REJECTED",
  SUPPLIER_PROCESSING: "SUPPLIER_PROCESSING",
  SUPPLIER_WITHDRAWN: "SUPPLIER_WITHDRAWN",
  SUPPLIER_OBJECTED: "SUPPLIER_OBJECTED",
  USER_CANCELLED: "USER_CANCELLED",
  SUPPLIER_ACCEPTED_COMPLETED: "SUPPLIER_ACCEPTED_COMPLETED",
};

export const STATUS_ICONS = {
  [STATUSES.AWAITING_EXPORT]: <LargeGreenSuccessIcon />,
  [STATUSES.PENDING_SUPPLIER]: <LargeGreenSuccessIcon />,
  [STATUSES.EXPORTED_SUPPLIER]: <LargeGreenSuccessIcon />,
  [STATUSES.SUPPLIER_ACCEPTED]: <LargeGreenSuccessIcon />,
  [STATUSES.SUPPLIER_REJECTED]: <LargePinkErrorIcon />,
  [STATUSES.SUPPLIER_PROCESSING]: <LargeGreenSuccessIcon />,
  [STATUSES.SUPPLIER_WITHDRAWN]: <LargePinkErrorIcon />,
  [STATUSES.SUPPLIER_OBJECTED]: <LargePinkErrorIcon />,
  [STATUSES.USER_CANCELLED]: <LargePinkErrorIcon />,
  [STATUSES.SUPPLIER_ACCEPTED_COMPLETED]: <LargeGreenSuccessIcon />
}